import React, { useState } from 'react';
import './styles.css';
import { FaAngleDown, FaAngleUp } from "react-icons/fa";
import ReactMarkdown from "react-markdown";

export default function InvisibleAccordion({ content, maxLength = 150, showMoreText = "Ver mais", showLessText = "Ver menos", editFunction }) {
    const [isExpanded, setIsExpanded] = useState(false);
    
    const shouldTruncate = content && content.length > maxLength;
    const displayContent = isExpanded ? content : content?.substring(0, maxLength) + '...';
    
    if (!content) return null;
    
    return (
        <div className="invisible-accordion">
            <div className="invisible-accordion-content">
                <ReactMarkdown>{displayContent || 'Carregando...'}</ReactMarkdown>
            </div>
            {shouldTruncate && (
                <div className="invisible-accordion-button-container">
                    {isExpanded && (
                       <button 
                            className="invisible-accordion-toggle me-4"
                            onClick={() => editFunction()}
                        >
                            Editar
                        </button>
                    )}

                    <button 
                        className="invisible-accordion-toggle"
                        onClick={() => setIsExpanded(!isExpanded)}
                    >
                        {isExpanded ? (
                            <p>{showLessText} <FaAngleUp/> </p>
                        ) : (
                            <p>{showMoreText} <FaAngleDown/> </p>
                        )}
                    </button>
                </div>
            )}
        </div>
    );
}
